(function () {
  // The collection template puts id="product-grid" on the <ul> itself; the search
  // template puts it on a wrapper <div> with the <ul> inside. Find the actual list
  // either way, otherwise appended results land in the wrong element or nowhere.
  const listIn = (root) => {
    if (!root) return null;
    return root.tagName === 'UL' ? root : root.querySelector('ul.product-grid, ul.grid');
  };

  const loadOffset = 700;
  let teardown = null;

  const init = () => {
    if (teardown) teardown();
    teardown = null;

    const grid = document.getElementById('product-grid');
    const sentinel = document.getElementById('infinite-scroll-sentinel');
    if (!grid || !sentinel) return;

    const list = listIn(grid);
    if (!list) return;

    let nextUrl = sentinel.dataset.nextUrl || grid.dataset.nextUrl;
    if (!nextUrl) { sentinel.remove(); return; }

    let loading = false;
    let active = true;

    const stop = () => {
      active = false;
      observer.disconnect();
      window.removeEventListener('scroll', checkPosition);
      window.removeEventListener('resize', checkPosition);
    };

    const loadMore = async () => {
      if (loading || !nextUrl || !active) return;
      loading = true;
      sentinel.classList.add('is-loading');

      try {
        const response = await fetch(nextUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);
        const html = await response.text();
        // Filters may have replaced the grid while this page was in flight.
        if (!active) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.getElementById('product-grid');
        const newList = listIn(newGrid);
        const newItems = newList ? newList.querySelectorAll(':scope > .grid__item') : [];
        newItems.forEach(item => list.appendChild(item));

        const newSentinel = doc.getElementById('infinite-scroll-sentinel');
        nextUrl = newSentinel ? newSentinel.dataset.nextUrl : (newGrid ? newGrid.dataset.nextUrl : null);
        grid.dataset.nextUrl = nextUrl || '';
        sentinel.dataset.nextUrl = nextUrl || '';

        if (!nextUrl) {
          stop();
          sentinel.remove();
        }
      } catch (e) {
        console.error('Infinite scroll failed:', e);
      } finally {
        loading = false;
        sentinel.classList.remove('is-loading');
        if (active) requestAnimationFrame(checkPosition);
      }
    };

    const checkPosition = () => {
      if (!active || !nextUrl || loading || !sentinel.isConnected) return;
      const rect = sentinel.getBoundingClientRect();
      if (rect.top <= window.innerHeight + loadOffset) {
        loadMore();
      }
    };

    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) loadMore(); },
      { rootMargin: '300px' }
    );

    observer.observe(sentinel);
    window.addEventListener('scroll', checkPosition, { passive: true });
    window.addEventListener('resize', checkPosition);
    checkPosition();

    teardown = stop;
  };

  init();

  // facets.js swaps the innerHTML of #ProductGridContainer when a filter, sort or
  // back/forward changes the results, which detaches the grid and sentinel this
  // instance was watching. Re-initialise on every swap so the new results keep
  // loading past the first page.
  const container = document.getElementById('ProductGridContainer');
  if (container) new MutationObserver(init).observe(container, { childList: true });
})();
